// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToChainAfter, addToChainBefore } from "@insite/client-framework/HandlerCreator";
import { chain as cartChain, GetCart } from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCart";
import {
    chain as currentCartChain,
    GetCart as GetCurrentCart,
} from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import {
    chain as orderApprovalChain,
    RequestDataFromApi as GetOrder,
} from "@insite/client-framework/Store/Data/OrderApprovals/Handlers/LoadOrderApproval";
import {
    chain as getQuoteChain,
    DispatchCompleteLoadQuote,
} from "@insite/client-framework/Store/Data/Quotes/Handlers/LoadQuote";

type HandlerType = Parameters<
    typeof GetCart | typeof GetCurrentCart | typeof GetOrder | typeof DispatchCompleteLoadQuote
>[0];

export const BuildNonStockLines = (props: HandlerType) => {
    let lines;
    if ("cart" in props.apiResult) {
        lines = props.apiResult.cart?.cartLines;
    } else {
        lines = props.apiResult?.cartLines;
    }

    lines?.every(cartLine => {
        cartLine.properties.isNonStockItem = !!(
            cartLine.properties.isWidgetNonStockItem &&
            cartLine.properties.isWidgetNonStockItem.toLocaleLowerCase() === "true"
        ) as any;

        if (cartLine.properties.isNonStockItem) {
            cartLine.productUri = "";
            cartLine.smallImagePath = "";
            cartLine.brand = null;
            cartLine.shortDescription = cartLine.properties.nonStockDescription;
            cartLine.altText = cartLine.properties.nonStockDescription;
            cartLine.erpNumber = cartLine.properties.nonStockPartNo;
            cartLine.manufacturerItem = "";
            cartLine.customerName = "";
            cartLine.properties.referenceNumbers = "";
        } else if (!cartLine.isActive || cartLine.isRestricted) {
            cartLine.productUri = "";
            cartLine.smallImagePath = "";
            cartLine.brand = null;
            cartLine.manufacturerItem = "";
            cartLine.customerName = "";
            cartLine.properties.referenceNumbers = "";
        }
        return true;
    });
};

addToChainAfter(cartChain, GetCart, BuildNonStockLines);
addToChainAfter(currentCartChain, GetCurrentCart, BuildNonStockLines);
addToChainAfter(orderApprovalChain, GetOrder, BuildNonStockLines);
addToChainBefore(getQuoteChain, DispatchCompleteLoadQuote, BuildNonStockLines);
